let backendHost;
const hostname = window && window.location && window.location.hostname;

if(hostname.indexOf('dev.incusig.com') > -1 ) {
  backendHost = 'https://devsrv.incusig.com';
} else if(hostname === 'incusig.com') { //Agregar el de la UNC
  backendHost = 'https://services.incusig.uncuyo.edu.ar';
} else {
  backendHost = 'https://services.incusig.uncuyo.edu.ar';
}

export const API_ROOT = `${backendHost}/api`;
export const APP_HOST = `${backendHost}`;



// WEBPACK FOOTER //
// ./src/variables/api-config.js